import PropTypes from 'prop-types';
import React from 'react';

import LogoAmex from '../svgs/payment/amex';
import LogoKlarna from '../svgs/payment/klarna';
import LogoMastercard from '../svgs/payment/mastercard';
import LogoSwish from '../svgs/payment/swish';
import LogoSwishDark from '../svgs/payment/swish-dark';
import LogoVisa from '../svgs/payment/visa';
import './shop.scss';

const PaymentMethods = ({ variant = 'light' }) => {
	const methods = [
		{ logo: LogoKlarna },
		{ logo: LogoMastercard, type: 'card' },
		{ logo: LogoVisa, type: 'card' },
		{ logo: variant === 'dark' ? LogoSwishDark : LogoSwish },
		{ logo: LogoAmex },
	];

	return (
		<div className="d-flex gap-2 flex-row payment-methods justify-content-center py-3">
			{methods.map(({ logo: Logo, type }, index) => (
				<div
					className={`payment-method-logo ${type === 'card' && 'payment-method-logo-card'} ${type === 'card' && variant === 'dark' ? 'payment-method-logo-card payment-method-logo-card-dark' : ''}`}
					key={index}
				>
					<Logo className="" />
				</div>
			))}
		</div>
	);
};

PaymentMethods.propTypes = {
	variant: PropTypes.string,
};

export default PaymentMethods;
